import { MailOutlined, MessageOutlined, SoundOutlined, StarOutlined } from '@ant-design/icons';
import { Radio, RadioChangeEvent } from 'antd';

import { ChatFilterTypeEnum } from '../../../../shared/constants/enums';
import { FetchChatParams } from '../../models';

import './styles.less';

export type ChatFilterProps = {
  setFetchChatData: React.Dispatch<React.SetStateAction<FetchChatParams | undefined>>;
  searchValue: string;
  chatFilterValue: ChatFilterTypeEnum;
  setChatFilterValue: (value: ChatFilterTypeEnum) => void;
};

const ChatFilter = ({ setFetchChatData, searchValue, chatFilterValue, setChatFilterValue }: ChatFilterProps) => {
  const onFilterChange = (e: RadioChangeEvent) => {
    setChatFilterValue(e.target.value);
    setFetchChatData?.({
      pageNumber: 1,
      chatSearchValue: searchValue,
      filter: e.target.value,
    });
  };

  return (
    <Radio.Group defaultValue="All" size="small" className="chat-filter" buttonStyle="outline" onChange={onFilterChange} value={chatFilterValue}>
      <Radio.Button value={ChatFilterTypeEnum.All}>
        <MessageOutlined title="All messages" />
      </Radio.Button>
      <Radio.Button value={ChatFilterTypeEnum.My}>
        <SoundOutlined title="Unmuted messages" />
      </Radio.Button>
      <Radio.Button value={ChatFilterTypeEnum.Unread}>
        <MailOutlined title="Unread messages" />
      </Radio.Button>
      <Radio.Button value={ChatFilterTypeEnum.Starred}>
        <StarOutlined title="Starred messages" />
      </Radio.Button>
    </Radio.Group>
  );
};

export default ChatFilter;
